/* import __COLOCATED_TEMPLATE__ from './form.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

import { AnnualTurnoverSelect } from '@repo/company-creation-kit/common/components/annual-turnover-select/annual-turnover-select';
import { AmountField } from '@repo/design-system-kit/components/amount-field/amount-field';
import { TransactionVolumeSelect } from '@repo/company-creation-kit/common/components/transaction-volume-select/transaction-volume-select';
import { ResponsiveCta } from '@repo/shared-kit/components/responsive-cta/responsive-cta';
import { dropTask } from 'ember-concurrency';

import { isOlderThanOrEqualOneYear } from 'register-partners-js/utils/dates';

import styles from './form.module.css';

const KYB_BUSINESS_FINANCES_FIELDS = ['yearlyTransactionVolume', 'maxSinglePaymentAmount'];

export default class OrganizationFinancesForm extends Component {
  styles = styles;
  button = ResponsiveCta;
  amountField = AmountField;
  annualTurnoverSelect = AnnualTurnoverSelect;
  transactionVolumeSelect = TransactionVolumeSelect;

  willDestroy() {
    super.willDestroy(...arguments);
    this.args.organization.set('didValidate', false);
  }

  submitTask = dropTask(async organization => {
    let { model, validations } = await organization.validate({
      on: [...KYB_BUSINESS_FINANCES_FIELDS, 'annualTurnover'],
    });

    if (validations.isValid) {
      return this.args.submitOrganizationTask.perform(organization);
    }

    model.set('didValidate', true);
  });

  handleGoBackTask = dropTask(async () => {
    await this.args.goBack();
  });

  @action
  handleReactAnnualTurnoverUpdate(value) {
    this.args.organization.annualTurnover = value;
  }

  @action
  handleReactMaxSinglePaymentAmountUpdate(value) {
    this.args.organization.maxSinglePaymentAmount = value === '' ? null : parseFloat(value);
  }

  @action
  handleReactTransactionVolumeUpdate(value) {
    this.args.organization.yearlyTransactionVolume = value;
  }

  get isRegisteredLessThanOneYearAgo() {
    let { legalRegistrationDate } = this.args.organization;
    return !legalRegistrationDate || !isOlderThanOrEqualOneYear(legalRegistrationDate);
  }
}
